import React from 'react';
import Banner from './Banner';
import ServiceTwo from './ServiceTwo';
import AboutTwo from './AboutTwo';
import CounterTwo from './CounterTwo';
import ProjectTwo from './ProjectTwo';
import TestimonialTwo from './TestimonialTwo';
import SlidingTextOne from '../../components/Common/SlidingTextOne ';
import TeamTwo from './TeamTwo';
import ServiceThree from './ServiceThree';
import FAQTwo from './FAQTwo';
import BlogTwo from './BlogTwo';
import ContactMain from '../contact/ContactMain';

// Original maroof home-2 section order, kept 1:1 — only the content of each
// section is swapped to ART-WER. ContactMain (template contact-page styling) is
// appended so the one-pager has a contact section.
const HomeTwoMain = () => {
	return (
		<>
			<Banner />
			<ServiceTwo />
			<AboutTwo />
			<CounterTwo />
			<ProjectTwo />
			<TestimonialTwo />
			<SlidingTextOne />
			<TeamTwo />
			<ServiceThree />
			<FAQTwo />
			<BlogTwo />
			<ContactMain />
		</>
	);
}

export default HomeTwoMain;
